// src/App.js
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { analytics } from "./firebaseConfig";
import { logEvent } from "firebase/analytics";


import Layout from "./components/Layout";
import MetaPixelPageView from "./MetaPixelPageView"; 


// PÚBLICAS
import Landing from "./pages/Landing";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import ForgotPassword from "./pages/auth/ForgotPassword";
import FormularioDirecto from "./pages/FormularioDirecto";
import Pago from "./pages/PagoGuest";

// PRIVADAS (Layout)
import Dashboard from "./pages/Dashboard";
import Songs from "./pages/Songs";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import LetrasListPage from "./pages/LetrasListPage";
import LetraDetailsPage from "./pages/LetraDetailsPage";
import CreateSongIdeas from "./pages/CreateSongIdeas";
import CreateLyrics from "./pages/CreateLyrics";
import CreateSongWithLyrics from "./pages/CreateSongWithLyrics";
import SongWizard from "./pages/SongWizard";
import SongDetailsPage from "./pages/SongDetails";
import ChatSupport from "./pages/ChatSupport";
import Paywall from "./pages/Paywall";
import CancionCompartir from "./pages/CancionCompartir";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";



function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (!analytics) return;
    const page_path = location.pathname + location.search;
    logEvent(analytics, "page_view", { page_path });
  }, [location]);

  return null;
}

function App() {
  const [user, setUser] = useState(undefined); // undefined=cargando, null=no logueado, obj=logueado

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
    return () => unsub();
  }, []);

  if (user === undefined) return <p>Cargando...</p>;

  const RequireAuth = ({ children }) => {
    if (!user) return <Navigate to="/login" replace />;
    return children;
  };

  const PublicOnly = ({ children }) => {
    if (user) return <Navigate to="/app" replace />;
    return children;
  };

  return (
    <>

     <MetaPixelPageView />
     <AnalyticsPageViews /> 
      <Routes>
        {/* ✅ Landing pública */}
        <Route path="/" element={<Landing />} />

        {/* ✅ Auth públicas */}
        <Route
          path="/login"
          element={
            <PublicOnly>
              <Login />
            </PublicOnly>
          }
        />
        <Route
          path="/signup"
          element={
            <PublicOnly>
              <Signup />
            </PublicOnly>
          }
        />
        <Route
          path="/forgot"
          element={
            <PublicOnly>
              <ForgotPassword />
            </PublicOnly>
          }
        />
        <Route path="/formulario" element={<FormularioDirecto />} />
        <Route path="/pagoguest" element={<Pago />} />

        <Route path="/politicaprivacidad" element={<PoliticaPrivacidad />} />


        {/* ✅ Wizard público (desde Landing) */}
        <Route path="/create" element={<SongWizard />} />
        <Route path="/share/:songId" element={<CancionCompartir />} />


        {/* ✅ Panel privado con Layout */}
        <Route
          path="/app"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />

          <Route path="songs" element={<Songs />} />
          <Route path="songs/:songId" element={<SongDetailsPage />} />

          <Route path="settings" element={<Settings />} />
          <Route path="perfil" element={<Profile />} />
          <Route path="letras" element={<LetrasListPage />} />
          <Route path="letras/:letraId" element={<LetraDetailsPage />} />
          <Route path="chat-support" element={<ChatSupport />} />
          <Route path="pagos" element={<Paywall />} />


          <Route path="crear-cancion" element={<CreateSongIdeas />} />
          <Route path="crear-letra" element={<CreateLyrics />} />
          <Route path="crear-can-con-letra" element={<CreateSongWithLyrics />} />

          {/* ✅ Wizard dentro del Layout */}
          <Route path="create" element={<SongWizard />} />
        </Route>

        {/* ✅ Cualquier otra ruta -> Landing */}
        <Route path="/panel" element={<Navigate to="/app" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
